<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div v-show="show_table" class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit" v-show="show_table">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->

				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>
		</div>


		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm" :api_url="sel_action"
			:api_action="upd_action" :api_method="edit_flag" :api_check="check_key" />

		<!-- 主界面内容显示 start -->
		<pre-table v-show="show_table" ref="file_table" @tab-event="refresh_data" :api_url="load_url"
			:pre_post="load_json" :pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
					<td class="long1">编辑页面</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[0].val" :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')"
					@dblclick="edit_data">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='imageList'">
							<ul>
								<li v-for="(t,id) in d.val" :index="id">
									<button @click="fun_show_detail(t)">{{t.f_name}}</button>
								</li>
							</ul>
						</div>
						{{d.val}}
					</td>
					<!-- </a> -->
					<td class="long1">
						<button @click="fun_show_editbook(user.item)">编辑</button>
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 弹窗编辑 start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item" v-show="show_btn">
								<pre-button @button-event="select_method" :pre_control="control" />
							</div>
							<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div>
						</div>
						<!-- 这里放主单据编辑内容-->
						<div class="content_edit">
							<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
								<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
									:key="index">
									<!-- {{handleImportView(item)}} -->

									<component :is="NextTickName(item.type)" :inData="checkJson(item)"
										@com-event="refresh_view_edit">
									</component>
								</div>
							</div>

							<div class="content_edit" v-show="file_show && show_FileMain">
								<div class="content_edit_item">
									<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;{{file_up}}</span>
								</div>
							</div>

						</div>
					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->

		<!-- 编辑页面 start -->
		<pre-book v-show="show_book" ref="mybook" @book-event="refresh_bookdata"></pre-book>
		<!-- 编辑页面 end -->

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_CommonLong,
		Method_CommonLongLong,
		Method_EasySelect,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	export default {
		name: "pre_base_table_new",
		components: {
			"pre-button": () => import("../per_mode/pre_btn_tan.vue"),
			"pre-btn-Excel": () => import("../per_old/pre_btn_control.vue"),
			"pre-table": () => import("./auto_view_table.vue"),
			'per-exceldown': () => import("./auto_excel_down.vue"),
			'per-excelup': () => import("./auto_excel_up.vue"),
			"pre-step": () => import("../per_old/pre_base_tan_step.vue"),
			"pre-book": () => import("../per_mode/pre_book_4.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',
				// 弹窗编辑
				show_tan: false,


				// 备注
				detail_data: '',
				//文件
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				show_note: false,

				max_row: [],
				// 主单据附件判断
				isFileMain: 0,
				show_FileMain: false,

				show_book: false,
				show_table: true,

				// 定义默认样式
				isTwo: '0',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',
				DTwoNone: "dlast-two-none",

			};
		},
		props: {
			pre_data: {
				type: String,
				default: ''
			}
		},
		watch: {
			pre_data(val) {
				if (val.length > 20) {
					// console.log(val);
					this.load_data();
				}
			},
			sheet_flag(val) {
				if (val == '已提交') {
					// this.show_btn = false;
					this.show_d_edit = false;
				} else {
					// this.show_btn = true;
					this.show_d_edit = true;
				}
			}

		},
		mounted: function() {
			// if (this.pre_data != '') {
			//   console.log('加载====');
			//   let that = this;
			//   this.$nextTick(function() {
			//     this.load_data();
			//   });
			// }
			let that = this;
			setTimeout(() => {
				console.log('加载静态页面建设====');
				that.load_data();
			}, 300)
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}
				if (type == 'save') {
					this.fun_upd('_add');
				}
			},
			refresh_view_edit_d: function(d, type) {
				console.log('明细编辑', d)
				for (let i = 0; i < this.d_parm.length; i++) {
					console.log(this.d_parm[i].key + '=' + this.d_parm[i].val);
					if (this.d_parm[i].key == d.key) {
						if (this.d_parm[i].type == 'select' || this.d_parm[i].type == 'radio') {
							this.d_parm[i].val = d.val;
							this.d_parm[i].sel_name = d.sel_name;
							break;
						} else if (this.d_parm[i].type == 'switch') {
							// 不能这样切换,因为 key不是唯一哦！！！！
							// 针对 切换模式的 附加参数的 设定
							for (let j = 0; j < this.d_parm.length; j++) {
								if (this.d_parm[j].key == 'io') {
									this.d_parm[j].val = d.io;
									break;
								}
							}
							this.d_parm[i].io = d.io;
							this.d_parm[i].val = d.val;
						} else {
							this.d_parm[i].val = d.val;
							break;
						}
					}
					console.log(this.parm[i].key + '=' + this.parm[i].val);
				}
				console.log('编辑更新', this.d_parm);


				if (type == 'save') {
					this.fun_d_save('_add');
				}
			},
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			CheckRN(str) {
				let t = '';
				t = str;
				let reg = new RegExp('\r\n', 'g');
				t = t.replace(reg, '<br/>')
				return t;
			},
			show_edit: function() {
				console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_tan_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_tan_bg").fadeIn("3000");
					$(".pre_tan_conten").fadeIn("3000");

				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				this.show_tan = false;

				// 关闭窗口 应该更新编辑信息？=》如果发生编辑 =》才应该进行更新
				// 保证 编辑后清空 全部查询
				// for (let i = 0; i < this.parm_sel.length; i++) {
				//   this.parm_sel[i].val = '';
				// }

				this.load_db_data();
				// this.$emit('base2-event', 'father');
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// console.log(this.pre_data);
				if (typeof(this.pre_data) === 'undefined' || this.pre_data == null || this.pre_data == '') {
					return
				}
				// 初始化最大行数
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.edit_flag = '';
				this.check_key = '';


				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_size = '0';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else {
						this.parm[j].val = '';
					}
				}

				let r = JSON.parse(this.pre_data);
				// console.log(r);

				this.title = r.title;
				this.control = r.control;
				this.isFileMain = r.isFileMain; //附件保存在主单据 | 还是明细
				// console.log('pass_step=' + this.pass_step);

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				this.edit_flag = r.upd_action.substring(0, 5);
				this.check_key = r.check_key;
				// console.log('编辑标识=' + this.edit_flag);

				this.file_action = r.file_action;
				this.p1 = r.p1;
				this.p2 = r.p2;
				this.p3 = r.p3;

				this.parm_sel = r.parm_sel;
				this.parm = r.parm;
				this.parm_th = r.parm_th;
				// console.log(this.parm_sel);
				// console.log(this.parm);

				if (typeof(r.isTwo) != "undefined" && r.isTwo != '') {
					this.isTwo = r.isTwo;
				}

				this.load_db_data();
			},
			select_method: function(type) {
				// console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw3 = dateFormatbyChina(this.kw3);
							}
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw4 = dateFormatbyChina(this.kw4);
							}
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
						case '10':
							this.kw10 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that
						.kw10, r);
				}, 200);
			},
			fun_change_title: function(type, new_title) {
				// console.log(new_title);
				if (type == 'main') {
					this.parm_th = JSON.parse(new_title);
				}
			},
			refresh_data: function(type, page, pagelength, backdata) {
				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE') {
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
							'', '', '',
							'', '', '', '', '', r)
					).then(res => {
						res = JSON.parse(res);

						this.element_loading = false;
						let res_page = [];
						res_page = res[0][0];

						if (res_page.flag == 1) {
							let bd = [];
							// console.log('allcount='+res_page.all_count)
							if (res_page.all_count > 0) {
								let t_list_data = res[1];
								// console.log(t_list_data);
								for (let i = 0; i < t_list_data.length; i++) {
									let arr = [];
									for (let j in t_list_data[i]) {
										let o = {};
										o.key = j;
										let temp_str = '';
										temp_str = t_list_data[i][j];
										if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
											temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
											temp_str = ReplaceAll(temp_str, '\n', "<br/>");
											temp_str = temp_str.replace("\\r\\n", "\r\n");
											temp_str = temp_str.replace("\\n", "\n");
										}
										o.val = temp_str;
										arr.push(o);
									}
									bd.push(arr);
								}
							}

							this.sel_row(bd[0], 'edit');

						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}

					});

				}

				if (this.sheet_flag.indexOf('提交成功') >= 0) {
					this.show_btn = false;
				} else {
					this.show_btn = true;
				}

				if (this.sheet_flag.indexOf('删除成功') == 0) {
					this.closeshow();
					return;
				}

				if (Number(page) > 0) {
					this.nowpage = page;
					// 更新编辑信息
					this.load_db_data();
					return;
				}

				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			new_blank: function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.d_detail = [];

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					this.parm[j].val = '';
				}

				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				// 双击打开界面,如果有明细,应该查询
				// console.log(this.d_upd_action);
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.fun_d_load();
				}
				this.show_edit();
			},
			sel_row: function(item, type) {
				console.log(item);
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							if (this.sheet_flag == '盘点完成') {
								this.show_btn = false;
								this.show_btn_ok = true;
							} else {
								this.show_btn = true;
								this.show_btn_ok = false;
							}
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}
				// console.log(this.parm)

				// 多附件时生效
				if (this.file_list_main.length > 0) {
					this.file_name = '';
					this.file_url = '';
					this.file_src = '';
					for (let i = 0; i < this.file_list_main.length; i++) {
						if (this.file_list_main[i].sheet_id == this.row_id) {
							this.file_name = BackSpecial(this.file_list_main[i].file_name);
							this.file_url = BackSpecial(this.file_list_main[i].file_url);
							this.file_src = BackSpecial(this.file_list_main[i].file_src);
						}
					}

					if (typeof(this.file_name) == 'undefined' || this.file_name == '') {
						this.file_show = false;
					} else {
						this.file_show = true;
					}
				}

				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[0].val);
				}



			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				// console.log('===END============')
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}

				if (this.edit_flag == 'base_') {
					this.fun_edit_base(type);
				} else {
					this.fun_edit_other(type);
				}


			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			fun_edit_base: function(type) {
				console.log('通用编辑方法 ID=' + this.row_id + ' sys_date=' + this.sys_date);
				let d = '';
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						// add 2022-02-15 必须强制删除所有特殊符号，特别是^
						let temp_val = '',
							temp_key = '',
							temp_type = '';
						temp_key = this.parm[i].key;
						temp_val = this.parm[i].val;
						temp_type = this.parm[i].type;

						if (temp_type == 'time' || temp_type == 'datetime') {
							temp_val = dateFormatbyChina(temp_val)
						}

						// if (temp_type == 'textarea') {
						//   temp_val = temp_val.replace(/\n/g, '<br/>');
						//   temp_val = temp_val.replace(/\s/g, '&nbsp;');
						// }

						d = d + temp_key + '=' + Word_Right_Delete(temp_val) + '^';
					}
				}
				console.log(d);
				d = d.slice(0, -1);

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_TableAll(this.upd_action + type, this.check_key, this.row_id, this.sys_date, d,
					r);
			},
			fun_edit_other: function(type) {
				console.log('自定义编辑方法');
				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {

						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.parm[i].val));
						} else if (this.parm[i].type == 'textarea') {
							// console.log(this.parm[i].val);
							let str = '';
							str = this.parm[i].val;
							// let str = this.parm[i].val;
							str = str.replace(/\n/g, '<br/>');
							str = str.replace(/\s/g, '&nbsp;');
							d.push(str);
						} else {
							// console.log(this.parm[i].val);
							d.push(this.parm[i].val);
						}
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				switch (this.edit_flag) {
					case 'exp15':
						this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
							r);
						break;
					case 'exp30':
						this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date,
							d, r);
						break;
					case 'exp50':
						this.upd_json = Method_CommonLongLong('data_' + this.upd_action + type, this.row_id, this
							.sys_date, d, r);
						break;
				}
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			//页面编辑 操作 start //////////////////////////////////////
			fun_show_editbook: function(item) {
				console.log(item);
				let o = {};
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							o.main_id = item[i].val;
							break;
						case 'page_title':
							o.title = item[i].val;
							break;
						case "page_class":
							o.p3 = item[i].val;
							break;
						default:
							break;
					}
				}
				o.file_action = this.file_action;
				o.p1 = this.p1;
				o.p2 = this.p2;

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybook'].init(o);
				});
				this.show_table = false;
				this.show_book = true;
			},
			refresh_bookdata: function(item) {
				console.log(item);
				this.show_table = true;
				this.show_book = false;
				this.load_db_data();
			},
			//页面编辑 操作 end //////////////////////////////////////
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.sel_action, 99999999, this.page_length, this.kw1, this
							.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10
						)
					});

					this.show_excel = true;
				}
			},
			setActiveRowBackColor: function(key, id, type) {
				console.log('key=' + key + ' id=' + id + ' type=' + type);
				key = key + '_';
				switch (type) {
					case 'detail':
						for (var i = 0; i < this.d_detail.length; i++) {
							// console.log(this.d_detail[i]);
							if (this.d_detail[i][0].val == id) {
								document.getElementById(key + id).style.background = '#92a4f3';
							} else {
								if (this.d_detail[i][0].val % 2 == 0) {
									document.getElementById(key + this.d_detail[i][0].val).style.background = '#fff';
								} else {
									document.getElementById(key + this.d_detail[i][0].val).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
					case 'main':
						break;
				}
			},

			//附件操作 start //////////////////////////////////////
			fun_show_detail: function(t) {
				console.log(t);
				this.file_url = '';
				this.file_src = '';
				this.file_url = decodeURI(t.f_url);
				this.file_src = decodeURI(t.f_src);
				let tt = BackSpecial(this.file_url);
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				this.fun_look_file();
			},
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_data = '';
				this.file_backdata = '';
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
					});
					return;
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				let fileobj = document.getElementById('hetong_file');

				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();

			},
			fun_look_file: function() {
				console.log('点击预览附件');
				// console.log(this.parm);
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_del","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';

				// //console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// //console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					if (this.isFileMain == '0') {
						that.fun_d_load();
					} else {
						this.load_db_data();
					}

				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_add","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					this.file_data +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						if (this.isFileMain == '0') {
							that.fun_d_load();
						} else {
							this.load_db_data();
						}

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// //console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// //console.log('上传长度=' + temp_data.size);
					// //console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						//console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_size":"' +
					this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// //console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// //console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				//console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				postdata =
					'{"action":"' + this.file_action + '_add","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","upfile_data":"' +
					'' +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '"}';

				// //console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_table_detail_new {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_table_detail_new td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header_new td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
	}



	.pre_leve_one {
		margin: 0px;
	}

	.content_edit_item label {
		display: inline-block;
		min-width: 96px;
	}


	.tab-row {
		display: block;
		overflow: auto;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>td:nth-last-child(2) {
		display: none;
	}
</style>


<!--

名称：通用基础模板3.0
日期：2022-03-06
作者：hj
目标：
方法 传入参数，
1、主界面固定按钮:查询、新建、备注说明,权限控制 导入和导出
2、弹窗编辑界面:通过权限控制 查询、增加、删除、修改、提交、导入、导出。、文件操作。
3、通过Json变量 parm_sel和动态组件 自动生成查询 区域
3、通过Json变量 parm    和动态组件 自动生成编辑 区域
3、通过sel标识+动态组件 构建查询 区域
4、通过 弹窗形式编辑

5、主单据功能: 分页查询+通用编辑+table 可以换行
    明细功能: 单页查询+通用编辑方法+文件  待测试

            {
              "name": "申请单",
              "val": "",
              "key": "val",
              "type": "text",
              "class": "long2",
              "sel_action":"data_alluser",  当需要从一列数据选择时，传入查询关键字
              "sel": "1"， 是否查询字段
              "p": "1",    是否传参自动
              "w": "1",    是否必填
              "x": "2"     布局行数
              "r": "1"     是否只读
            }


        -->
